<template>
    <svg  viewBox="0 0 15 10" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7071 0.292893C10.3166 -0.0976311 9.68342 -0.0976311 9.29289 0.292893C8.90237 0.683417 8.90237 1.31658 9.29289 1.70711L11.5858 4H0V6H11.5858L9.29289 8.29289C8.90237 8.68342 8.90237 9.31658 9.29289 9.70711C9.68342 10.0976 10.3166 10.0976 10.7071 9.70711L14.7071 5.70711C15.0976 5.31658 15.0976 4.68342 14.7071 4.29289L10.7071 0.292893Z" />
    </svg>
</template>

<script>
export default {
    name: "ArrowRight"
};
</script>
